import { render, staticRenderFns } from "./media-canva.vue?vue&type=template&id=70620394&scoped=true&"
import script from "./media-canva.vue?vue&type=script&lang=js&"
export * from "./media-canva.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70620394",
  null
  
)

export default component.exports